module.exports = __webpack_public_path__ + "static/1camp_square-9df4582ec8664ed072d91fe37afc2c21.jpg";